// AUTO-EXTRACTED from SourceSecurity.com via Claude Sonnet 4.6 + Playwright MCP
// Generated: 2026-05-16
// Specs parsed from public product spec sheets; no values invented.
// All entries marked verified: false — reviewer must spot-check before promotion.

import type { EquipmentCatalogEntry } from '../equipmentCatalogEntry';

export const SS_INDOOR_SOUNDERS: EquipmentCatalogEntry[] = [
  {
    id: "ss-dsc-pc4702bp",
    manufacturer: "DSC",
    model: "PC4702BP",
    category: "indoor-sounder",
    tagline: "DSC PC4702BP MAXSYS dual-zone bell panel",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dsc-pc4702bp-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"acoustic":"piezo"},
  },
];
